import styled from 'styled-components';
import colors from '../../../config/colors';
import {memo} from 'react';
const theme: any = {
    white: {
      background: `${colors.WHITE};`,
      minHeight: 'auto',
      padding: '40px 80px',
      margin: '30px 0',
      paddingMob: '15px 0'
    },
    white_small_padding: {
      background: `${colors.WHITE};`,
      minHeight: 'auto',
      padding: '20px 80px',
      margin: '0',
      paddingMob: '15px 0'
    },
    gray_extra_light_no_height: {
      background: `${colors.GRAY_EXTRA_LIGHT};`,
      minHeight: 'auto',
      padding: '40px 80px',
      margin: '30px 0',
      paddingMob: '15px'
    },
    gray_extra_light: {
      background: `${colors.GRAY_EXTRA_LIGHT};`,
      minHeight: '600px',
      padding: '40px 80px',
      margin: '30px 0',
      paddingMob: '15px'
    },
  };

const MainWrapper = styled.div`
  background-color: ${props => theme[props.theme].background};
  padding: ${props => theme[props.theme].padding};
  position: relative;
  overflow: hidden;
  margin: ${props => theme[props.theme].margin};
  min-height: ${props => theme[props.theme].minHeight};

  @media (max-width: 1200px) {
    padding: 40px;
  }

  @media (max-width: 1024px) {
    padding: ${props => theme[props.theme].paddingMob};
  }
`;

MainWrapper.defaultProps = {
    theme: 'white'
  }

export default memo(MainWrapper);
